// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"J","header":"K","title":"L","doneButton":"M"};